import { Component, OnInit } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { DatePipe } from "@angular/common";
import { MySharedService } from '../App/shared.service';
import { ActivatedRoute, Router } from '@angular/router';

declare function ExportToExcel(item: any[], workSheetName: string, keys: any, Columns?: any): void;

@Component({
    templateUrl: './AppViews/Invoice/Invoice.html'
})


export class InvoiceComponent implements OnInit {
    constants: Constants;
    projectList: any = [];
    siteUserItems: any = [];
    public showLoader = false;
    selectAll: any = false;
    userList: any = [];
    selfuser: boolean = true;
    userDetail: any;
    public Customers: any = [];
    timesheetInvoiceItems = [];
    Search:any;

    filter: any = { 'CustomerId': "", 'FromDate': moment().format('DD/MM/YYYY'), 'ToDate': moment().format('DD/MM/YYYY') };


    constructor(private _httpService: HTTPService, private _sharedService: MySharedService, private datePipe: DatePipe, private route: ActivatedRoute, private _route: Router) {
        this.constants = new Constants();
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
        //  this.filter={'TeamId': this.timesheetItems.TeamID, 'UserId': this.timesheetItems.SiteUserId}
    }

    ngOnInit() {

        var dt = new Date();
        var month = new Array();
        month[0] = "01";
        month[1] = "02";
        month[2] = "03";
        month[3] = "04";
        month[4] = "05";
        month[5] = "06";
        month[6] = "07";
        month[7] = "08";
        month[8] = "09";
        month[9] = "10";
        month[10] = "11";
        month[11] = "12";
        var mth = month[dt.getMonth()];
        var yr = dt.getFullYear();
        var newDate = '01/' + mth + '/' + yr;
        this.filter.FromDate = newDate;
        this.getCustomer();
        this.GetTimesheetBillingData();
    }

    ngAfterViewInit() {

        $('.date').datetimepicker({
            format: 'DD/MM/YYYY'
        });

        $("#show-filter").click(function () { $(".filter-form").slideToggle() });

    }

    public getCustomer() {
        this.showLoader = true;
        this._httpService.ajaxPost('Customer/GetCustomer', { "CustomerId": 0, "CountryId": 0, "CustomerStatus": true }).subscribe(
            data => {
                this.Customers = data["CustomerList"];
            },
            err => {
                this.showLoader = false;
            },
            () => {
                this.showLoader = false
            }
        );
    }

    GetTimesheetBillingData() {
        this.showLoader = true;
        this.selectAll = false;
        this._httpService.ajaxPost("TimesheetInvoice/GetTimesheetInvoice",
            {
                "BillId": 0,
                "CustomerId": this.filter.CustomerId,
                "FromDate": this.filter.FromDate,
                "ToDate": this.filter.ToDate,
                "LoggedInUser": this.userDetail.SiteUserId
            }).subscribe(

                data => {
                    this.timesheetInvoiceItems = data["TimesheetInvoiceList"];
                    this.timesheetInvoiceItems.forEach(element => {
                        var VATAmount = String(Number(element.DiscountedAmount) * (Number(element.VATRate) / 100));
                        var FinalBillAmount= String(Number(element.DiscountedAmount) + Number(VATAmount));
                        element.FinalBillAmount = parseFloat(FinalBillAmount).toFixed(2);

                    });
                },
                err => {
                    console.log("GetInvoiceTimesheetList Failed");
                    this.showLoader = false;
                    this._sharedService.ShowMessage(this.constants.globalError);

                },
                () => {
                    this.showLoader = false;
                });
    }

    printPDf(BillId)
    {
          localStorage.setItem("BillId",JSON.stringify(BillId));          
          this._route.navigateByUrl("/invoicePrint"); 
    }
}



/** WEBPACK FOOTER **
 ** ./TypeScripts/Invoice/Invoice.component.ts
 **/